import api from './api';

export const userService = {
  getDashboard: async () => {
    const response = await api.get('/user/dashboard');
    return response.data;
  },
  getProfile: async () => {
    const response = await api.get('/user/profile');
    return response.data;
  },
  getBalance: async () => {
    const response = await api.get('/user/balance');
    return response.data;
  },
  getTradings: async () => {
    const response = await api.get('/user/tradings');
    return response.data;
  },
  getWithdrawals: async () => {
    const response = await api.get('/user/withdrawals');
    return response.data;
  },
  createWithdraw: async (payload: { amount: number; btcAddress: string }) => {
    const response = await api.post('/user/withdraw', payload);
    return response.data;
  },
  getKycStatus: async () => {
    const response = await api.get('/user/kyc-status');
    return response.data;
  },
  // Updated to point to the valid administrative broadcast address endpoint as per the latest specification
  getBtcAddress: async () => {
    const response = await api.get('/admin/btc-address');
    return response.data;
  },
  uploadKyc: async (file: File) => {
    const formData = new FormData();
    formData.append('document', file);
    const response = await api.post('/user/upload-kyc', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }
};